import { render, staticRenderFns } from "./SubmitAssignDialog.vue?vue&type=template&id=420b4506&scoped=true"
import script from "./SubmitAssignDialog.vue?vue&type=script&lang=js"
export * from "./SubmitAssignDialog.vue?vue&type=script&lang=js"
import style0 from "./SubmitAssignDialog.vue?vue&type=style&index=0&id=420b4506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420b4506",
  null
  
)

export default component.exports